// Recruitics Tracking Script
export const recruiticsScript = () => {
  return `<script src="//jsv3.recruitics.com/partner/9be65813-c024-11e8-9161-ddd57874f75f.js"></script>`;
};
